import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { DocumentManagementService } from 'src/framework/services/manage-doc.service';
import { SelectItemGroup, SelectItem, MessageService } from 'primeng';
import * as _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';
import { LanguageService } from 'src/framework/services/language.service';


@Component({
  selector: 'app-edit-doc',
  templateUrl: './edit-doc.component.html',
  styleUrls: ['./edit-doc.component.css'],
  providers: [MessageService]

})

export class EditDocumentComponent implements OnInit {

  @Input() langDocList: any;
  @Input() canApproveOtherLang: boolean;
  @Input() isAllNonApproved: boolean;
  @Input() absoluteFilePath: string;
  @Output() outSaveVersion = new EventEmitter<any>();
  @ViewChild("ctrlFileUpload") ctrlFileUpload: ElementRef;

  isNewDraft = false;
  sourceDocToClone: any = {};
  emitVersionResponse: any = {
    isNewVersion: false,
    saveType: '',
    versionData: {}
  };
  docTypeList: any[];
  docTypeKeyValueList: SelectItem[];
  pUpload: File;
  showDraftButton: boolean = false;
  showDraftPanel: boolean = false;
  showLeftPanel: boolean = false;
  leftPanelDoc: any = {};
  allowedFileTypes: string;
  localeSetting: any;

  authorizerList: SelectItemGroup[] = [
    {
      label: 'Owners',
      items: []
    },
    {
      label: 'Reviewers',
      items: []
    },
    {
      label: 'PPAP',
      items: []
    },
    {
      label: 'Sr. Managers',
      items: []
    },
    {
      label: 'Admin',
      items: []
    }
  ];

  engagementDetail = {
    appLanguage: 1,
    engagementId: 1,
    engagementName: '',
    engStatusId: 1,
    engStatusName: '',
    engInitialDate: null,
    engLanguage: [{
      "languageId": 1,
      "languageName": "English",
      "languageFlagPath": "../../assets/flags/English.png"
    },
    {
      "languageId": 2,
      "languageName": "French",
      "languageFlagPath": "../../assets/flags/french.png"

    },
    {
      "languageId": 3,
      "languageName": "Spanish",
      "languageFlagPath": "../../assets/flags/spanish.png"

    }],

  }

  documentForm: FormGroup;
  formSubmitted: boolean;
  calendarYearRange: string;
  showDateMandatory: boolean;
  docDateDesc: any;
  docInfo: string;
  draftDocValue: any;
  userDetail: any = {};
  showApproveButton: boolean = false;
  isApproverSelected: boolean = false;
  appLangList: any;
  errorMsg: string = '';
  showEditor = false;
  tinyMceConfig: any;
  approverRemovedNote: string;
  rawApproverList: any[] = [];
  selectedAppLanguage: any;
  selectedAppLanguageJson: any;
  defaultEnglishJson: any;
  selectedLangDocTypeJson: any;
  defaultEngDocTypeJson: any;
  selectedLangStatusJson: any;
  defaultEngStatusJson: any;
  selectedLangDateJson: any;
  defaultEngDateJson: any;
  islabelLoaded: boolean = false;
  isDocTypeLoaded: boolean = false;
  isFontLoaded: boolean = false;
  apporveBtnState: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private manageDocService: DocumentManagementService,
    private messageService: MessageService,
    private spinner: NgxSpinnerService, private languageService: LanguageService) {
    this.allowedFileTypes = ".doc,.docx,.dot,.jpg,.jpeg,.png,.tif,.pdf,.xls,.xlsx,.xlsb";
    this.calendarYearRange = (new Date().getUTCFullYear() - 10) + ':' + (new Date().getUTCFullYear() + 1);
  }

  ngOnInit(): void {

    this.approverRemovedNote = null;
    if (sessionStorage.getItem('userDetail')) {
      this.userDetail = JSON.parse(sessionStorage.getItem('userDetail'));
    }
    this.configureTinyMce();
    this.loadLanguageLabel()
      .then(res => {
        this.initializeEngagementData()
          .then((res) => {
            this.buildForm();
            this.getDocType()
              .then(res => {
                this.setDocDateValidators();
                this.getApproverList(+this.engagementDetail.engagementId)
                  .then(res => {
                    this.formatApproverList()
                      .then(res => {
                        this.initializeFormControls()
                      })
                      .catch(err => {
                        console.log(err);
                      })
                  })
                  .catch(err => {
                    console.log(err);
                  })
              })
              .catch(err => {
                console.log(err);
              })
          })
          .catch(err => {
            console.log(err);
          })
      })
      .catch(err => {
        console.log(err);
      });
  }

  initializeEngagementData() {

    let minYear;

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('appLanguageList')) {
        this.appLangList = JSON.parse(sessionStorage.getItem('appLanguageList'));
      }

      if (sessionStorage.getItem('engagementDetail')) {
        this.engagementDetail = JSON.parse(sessionStorage.getItem('engagementDetail'));
        minYear =
          Number(new Date().getUTCFullYear() - 10) <
            Number(new Date(this.engagementDetail?.engInitialDate).getUTCFullYear()) ?
            Number(new Date().getUTCFullYear() - 10) :
            Number(new Date(this.engagementDetail?.engInitialDate).getUTCFullYear());

        this.calendarYearRange = minYear + ':' + (new Date().getUTCFullYear() + 1);
      }
      resolve(1);
    });
  }

  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishDocTypeMappings, selectedLangDocTypeMappings: any;
    let englishStatusMappings, selectedLangStatusMappings: any;
    let englishDateMappings, selectedLangDateMappings: any;

    return new Promise((resolve, reject) => {
      this.spinner.show();
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedAppLanguage = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageService.currentData.subscribe(data => {
        this.selectedAppLanguage = data.Id
        this.isFontLoaded = false;
      });


      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.EditDocument.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishDocTypeMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.DocumentTypes.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishStatusMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishDateMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.EditDocument.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangDocTypeMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.DocumentTypes.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangStatusMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangDateMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];
          }
          else {
            if (Number(this.selectedAppLanguage) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.EditDocument.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangDocTypeMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.DocumentTypes.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangStatusMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangDateMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangDocTypeMappings = englishDocTypeMappings;
              selectedLangStatusMappings = englishStatusMappings;
              selectedLangDateMappings = englishDateMappings;
            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings?.languageMappingJSON ?? englishLanguageMappings.languageMappingJSON);
          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedLangDocTypeJson = JSON.parse(selectedLangDocTypeMappings?.languageMappingJSON ?? englishDocTypeMappings.languageMappingJSON);
          this.defaultEngDocTypeJson = JSON.parse(englishDocTypeMappings.languageMappingJSON);

          this.selectedLangStatusJson = JSON.parse(selectedLangStatusMappings?.languageMappingJSON ?? englishStatusMappings.languageMappingJSON);
          this.defaultEngStatusJson = JSON.parse(englishStatusMappings.languageMappingJSON);

          this.selectedLangDateJson = JSON.parse(selectedLangDateMappings?.languageMappingJSON ?? englishDateMappings.languageMappingJSON);
          this.defaultEngDateJson = JSON.parse(englishDateMappings.languageMappingJSON);

          this.setCalendarLocale();
          this.isFontLoaded = true;
          this.islabelLoaded = true;
          this.spinner.hide();
          resolve(1);
        }
        else {
          this.spinner.hide();
        }
      });
    })
      .catch(err => {
        this.spinner.hide();

        console.log(err);
      });
  }

  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }

  docTypeReplacer(labelKey): string {
    return this.selectedLangDocTypeJson[labelKey]?.trim() ? this.selectedLangDocTypeJson[labelKey] ?? 'text not found' : this.defaultEngDocTypeJson[labelKey] ?? 'text not found';
  }

  statusReplacer(labelKey): string {
    return this.selectedLangStatusJson[labelKey]?.trim() ? this.selectedLangStatusJson[labelKey] ?? 'text not found' : this.defaultEngStatusJson[labelKey] ?? 'text not found';
  }

  calendarReplacer(labelKey): string {
    return this.selectedLangDateJson[labelKey]?.trim() ? this.selectedLangDateJson[labelKey] ?? 'text not found' : this.defaultEngDateJson[labelKey] ?? 'text not found';
  }

  dayOrMonthNameShort(name, length): string {
    let shortName = '';
    if (name?.trim()?.length == 0)
      shortName = 'Text not found';
    else if (name?.trim()?.length > 0 && name?.trim()?.length < length)
      shortName = name;
    else
      shortName = name.substr(0, length);
    return shortName;
  }

  setCalendarLocale() {
    this.localeSetting = {
      firstDayOfWeek: 0,
      dayNames: [
        this.calendarReplacer("SUN"),
        this.calendarReplacer("MON"), this.calendarReplacer("TUE"), this.calendarReplacer("WED"),
        this.calendarReplacer("THU"), this.calendarReplacer("FRI"), this.calendarReplacer("SAT")
      ],
      dayNamesShort: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 3), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 3), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 3), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 3)
      ],
      dayNamesMin: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 1), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 1), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 1), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 1)
      ],
      monthNames: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
      ],
      monthNamesShort: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
      ],
      today: this.calendarReplacer('TODAY'),
      clear: this.calendarReplacer('CLEAR')
    }
  }

  buildForm() {
    this.documentForm = this.formBuilder.group({
      docStatus: [''],
      documentLink: ['None'],
      documentHash: [''],
      docTitle: ['', Validators.required],
      docDescription: ['', Validators.required],
      docType: ['', Validators.required],
      docDate: [''],
      approvalRequestedFrom: ['']
    });

  }


  getDocType() {
    return new Promise((resolve, reject) => {

      this.manageDocService.getDocType().subscribe(res => {
        if (res) {
          //success
          this.docTypeKeyValueList = res.data.map(x => ({
            label: this.docTypeReplacer(x.documentTypeId),
            value: x.documentTypeId
          }));
          this.docTypeList = res.data;
        } else {
          //display error
        }
        resolve(1);
      });
    });
  }

  configureTinyMce() {
    const that = this;
    this.tinyMceConfig = {
      branding: false,
      toolbar_mode: 'sliding',
      toolbar_sticky: false,
      inline: false,
      statusbar: false,
      theme: "silver",
      resize: false,
      skin: "oxide",
      skin_url: 'assets/skins/ui/oxide',
      base_url: '/tinymce',  
      suffix: '.min',
      plugins: [
        "print preview   importcss autoresize searchreplace autolink autosave save directionality  visualblocks visualchars fullscreen image link media  template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists  wordcount   imagetools textpattern noneditable help code charmap  emoticons paste table"],
      menubar: 'edit insert view  format table tools help',
      force_br_newlines: false,
      //force_p_newlines: false,
      //forced_root_block: '',
      // content_css: [
      //   '//fonts.googleapis.com/css?family=EYFontRegular',
      // ],
      paste_as_text: true,
      paste_text_sticky: true,
      font_formats: 'EYFontRegular=EYFontRegular;',
      theme_advanced_fonts: "EYFontRegular=EYFontRegular",
      extended_valid_elements: "@[id|class|title|style|onmouseover|onclick]," +
        "a[name|href=javascript:void(0);|target|title|alt]," +
        "#div,blockquote,-ol,-ul,-li,br,img[src|height|width],-sub,-sup,-b,-i,-u," +
        "-span[data-mce-type],hr,",
      toolbar: 'bold italic backcolor | ' +
        'bullist numlist outdent indent | alignright alignjustify |' +
        '   alignleft aligncenter | removeformat |' +
        ' help '
    };
  }

  getApproverList(engagementId) {
    return new Promise((resolve, reject) => {

      this.spinner.show();
      this.manageDocService.getApproverList(engagementId).subscribe(res => {
        if (res.status === 0) {
          //success
          this.rawApproverList = res.data;
          this.spinner.hide();
        } else {
          //display error
          this.spinner.hide();
        }
        resolve(1);
      });
    });
  }

  formatApproverList() {
    return new Promise((resolve, reject) => {
      let ownerList, reviewerList, partnerList, srMangerList, adminList: any[] = [];
      this.authorizerList = [];

      this.authorizerList.push({
        label: this.labelReplacer('lblOwner'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblReviewer'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblPPAP'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblSrManager'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblAdmin'),
        items: []
      });

      if (this.rawApproverList.length > 0) {
        ownerList = this.rawApproverList[0];
        reviewerList = this.rawApproverList[1];
        partnerList = this.rawApproverList[2];
        srMangerList = this.rawApproverList[3];
        adminList = this.rawApproverList[4];

        this.setDesignationList(ownerList, 0);
        this.setDesignationList(reviewerList, 1);
        this.setDesignationList(partnerList, 2);
        this.setDesignationList(srMangerList, 3);
        this.setDesignationList(adminList, 4);

      }

      resolve(1);
    })
      .catch(error => {
        console.log(error);
      })
  }


  

  setDesignationList(userList, index) {

    if (userList.length > 0) {
      this.authorizerList[index].items = userList.map(x => ({
        label: x.emailId,
        value: x.emailId
      }));
    }
  }

  getStatusPillClass(statusId) {

    let pillClass = '';
    if (statusId) {
      if (statusId === 2 || statusId === 4 || statusId === 7)
        pillClass = 'pill pill--approved m-0 ml-2';
      else if (statusId === 1)
        pillClass = 'pill pill--closed m-0 ml-2';
      else if (statusId === 3 || statusId === 6)
        pillClass = 'pill pill--failed m-0 ml-2';
    }

    return pillClass;
  }

  initializeFormControls() {

    this.draftDocValue = {};
    this.showLeftPanel = false;
    this.showDraftPanel = false;

    if (this.langDocList) {
      this.showDraftButton = this.langDocList['showDraftButton'];
      if (this.showDraftButton) {
        //keep right panel hidden
        this.isNewDraft = true;
        this.showLeftPanel = this.showDraftButton;
        this.showDraftPanel = !this.showDraftButton;
        //bind left panel with data
        this.leftPanelDoc = this.langDocList['languageDocList'][0];
      }
      else //if show draft button = false
      {
        //show draft panel
        this.draftDocValue['sourceVersionId'] = 0;
        this.showDraftPanel = !this.showDraftButton;

        //show both existing approved/unapproved and draft
        if (this.langDocList['languageDocList']?.length > 1) {
          this.showLeftPanel = true;
          this.isNewDraft = false;
          //show approved/unapproved document
          this.leftPanelDoc = this.langDocList['languageDocList'][0];
          //show draft document
          this.draftDocValue = this.langDocList['languageDocList'][1];
          this.setDraftDocValue();
        }
        else if (this.langDocList['languageDocList']?.length > 0) {
          //show existing/new draft document
          this.draftDocValue = this.langDocList['languageDocList'][0];
          this.isNewDraft = this.draftDocValue.docVersionId === 0 ? true : false;
          this.setDraftDocValue();
        }
        else {
          this.isNewDraft = true;
        }

        //prepopulate doc type based validation and details
        this.getDocTypeDetails(this.draftDocValue['documentTypeId']);

      }

    }

  }

  setDraftDocValue() {
    this.documentForm.patchValue({
      docStatus: this.draftDocValue['statusName'],
      documentLink: this.draftDocValue['documentLink'],
      documentHash: this.draftDocValue['documentHash'],
      docTitle: this.draftDocValue['documentTitle'],
      docDescription: this.draftDocValue['documentDescription'],
      docType: this.draftDocValue['documentTypeId'],
      docDate: this.draftDocValue['documentDate'] === null ? null : new Date(this.draftDocValue['documentDate']),
      approvalRequestedFrom: this.draftDocValue['approvalRequestedFromGpn']
    });

    this.approverCheck(this.draftDocValue['approvalRequestedFromGpn']);
  }

  setDocDateValidators() {
    this.docDateDesc = this.labelReplacer('txtDocDate');

    this.documentForm.get('docType').valueChanges
      .subscribe(selectedDocType => {
        this.getDocTypeDetails(selectedDocType);
      });

  }

  getDocTypeDetails(docTypeValue) {
    const docDateControl = this.documentForm.get('docDate');
    let docTypeData = this.docTypeList.filter(x => x.documentTypeId === docTypeValue)[0];
    if (docTypeValue) {
      if (docTypeValue === 1 ||
        docTypeValue === 2 ||
        docTypeValue === 3 ||
        docTypeValue === 5) {
        docDateControl.setValidators([Validators.required]);

        this.showDateMandatory = true;
      }
      else if (docTypeValue === 4 ||
        docTypeValue === 6) {
        docDateControl.setValidators(null);
        
        if (docDateControl?.value == null ||
          docDateControl?.value == undefined ||
          docDateControl?.value == '') {
          this.documentForm.patchValue({
            docDate: new Date()
          });
        }

        this.showDateMandatory = false;

      }

      this.docInfo = '';
      this.docDateDesc = this.docTypeReplacer('d' + docTypeValue.toString());//docTypeData?.descriptionOfDate;
      if (docTypeData?.preferredNamingConvention && docTypeData?.preferredNamingConvention != '')
        this.docInfo = this.labelReplacer('msgFileNameFyi') + ': ' + this.docTypeReplacer('f' + docTypeValue.toString()) + ', ';
      this.docInfo += this.labelReplacer('msgProtectPdf') + ' ' + (docTypeData?.protectPdf ? this.docTypeReplacer('ppdftrue') : this.docTypeReplacer('ppdffalse'));
    }

    docDateControl.updateValueAndValidity();
  }

  saveVersion() {
    this.apporveBtnState = true;
    this.saveDocumentVersion('save')
      .then(res => {
        this.apporveBtnState = false;
        this.outSaveVersion.emit(this.emitVersionResponse);
      })
      .catch(err => {
        this.manageDocService.deleteDocVersion(this.emitVersionResponse?.versionData).subscribe(res => {
          if (res.status === 0) {

          }
          else {
          }
        });
        this.apporveBtnState = false;
      })
  }

  saveDocumentVersion(saveType: string): Promise<boolean> {
    this.spinner.show();
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      let fileToUpload: any;
      let fileCopy = false;
      this.emitVersionResponse = {};

      this.formSubmitted = true;
      // stop here if form is invalid
      if (this.documentForm.invalid) {
        this.spinner.hide();
        return;
      }
      else {

        if (this.pUpload) {

          fileToUpload = <File>this.pUpload;
          if (fileToUpload.name.includes('eicar.com')) {
            this.spinner.hide();
            return;
          }
          else {
            formData.append('file', fileToUpload, fileToUpload.name);
            fileCopy = false;
          }

        }
        else {
          if (this.draftDocValue?.sourceVersionId > 0)
            fileCopy = true;
        }


        let documentData = {
          ...this.documentForm.value,
          'engagementId': this.engagementDetail.engagementId,
          'languageId': this.draftDocValue?.languageId,
          'docId': this.draftDocValue?.docId,
          'documentDate': (this.documentForm.controls['docDate']?.value == null ||
            this.documentForm.controls['docDate']?.value == undefined ||
            this.documentForm.controls['docDate']?.value == '') ? null : new Date(this.documentForm.controls['docDate'].value).toDateString(),
          'docVersionId': this.isNewDraft ? 0 : this.draftDocValue.docVersionId,
          'statusId': 1,
          'cloneFilePath': fileCopy ? this.draftDocValue.docId + '_' + this.draftDocValue.sourceVersionId : null,
          'absoluteFilePath': this.absoluteFilePath
        }

        this.emitVersionResponse.isNewVersion = this.isNewDraft;

        formData.append('fileJson', JSON.stringify(documentData));

        this.manageDocService.saveDocumentVersion(formData).subscribe(res => {
          if (res?.status === 0) {
            //success
            this.emitVersionResponse.versionData = res.data;
            this.emitVersionResponse.saveType = saveType;

            resolve(true);


          } else {
            //display error
            if (res?.status === 2) {

              if (res?.data?.toLowerCase() === 'pendingdraftsaveerror') {
                this.errorMsg = 'Unable to save document as it is no longer a draft.';
                this.emitVersionResponse.saveType = 'draftApproved';
              }
              else if (res?.data?.toLowerCase() === 'versionnotfound') {
                this.emitVersionResponse.saveType = 'draftDeleted';
                this.errorMsg = 'Unable to save document as it no longer exists.';
              }
              else {
                this.errorMsg = res?.data ?? '';
              }

              this.messageService.add({
                summary: 'Error : Unable to save document version',
                detail: this.errorMsg,
                sticky: false,
                severity: 'error'
              });
              this.outSaveVersion.emit(this.emitVersionResponse);

            }
            else {
              this.errorMsg = res?.message;

              this.messageService.add({
                summary: 'Error : Unable to save document version',
                detail: this.errorMsg,
                sticky: false,
                severity: 'error'
              });
              this.spinner.hide();

            }
            reject(false);
          }
        });

      }
    });

  }

  onUpload(event) {
    for (let file of event.files) {
      this.pUpload = file;
      this.documentForm.patchValue({
        documentLink: this.pUpload.name
      });
      //this.draftDocValue.documentLink = this.pUpload.name;
    }
  }

  cloneDraft(cloneDoc) {
    this.showDraftButton = false;
    this.isNewDraft = true;
    this.draftDocValue = _.cloneDeep(cloneDoc);
    this.draftDocValue['sourceVersionId'] = cloneDoc.docVersionId;
    this.draftDocValue['docVersionId'] = 0;
    this.documentForm.patchValue({
      docStatus: cloneDoc['statusName'],
      documentLink: cloneDoc['documentLink'],
      documentHash: cloneDoc['documentHash'],
      docTitle: cloneDoc['documentTitle'],
      docDescription: cloneDoc['documentDescription'],
      docType: cloneDoc['documentTypeId'],
      docDate: cloneDoc['documentDate'] === null ? null : new Date(cloneDoc['documentDate'])
      //approvalRequestedFrom: cloneDoc['approvalRequestedFromGpn']
    });

    //prepopulate doc type based validation and details
    this.getDocTypeDetails(cloneDoc['documentTypeId']);
    this.showDraftPanel = true;
  }

  resetForm() {
    this.formSubmitted = false;
    this.documentForm.controls['docTitle'].setValue('');
    this.documentForm.controls['docDescription'].setValue('');
    this.documentForm.controls['documentHash'].setValue('');
    this.documentForm.controls['documentLink'].setValue('');
    this.documentForm.controls['docType'].setValue('');
    this.documentForm.controls['docDate'].setValue('');
    this.documentForm.controls['approvalRequestedFrom'].setValue('');
    this.pUpload = null;
    this.docInfo = '';
    this.docDateDesc = 'Document Date';
    this.ctrlFileUpload['files'] = [];
    this.isNewDraft = false;
    this.sourceDocToClone = {};
  }

  approverChange(event) {
    this.approverCheck(event?.value);
  }

  approverCheck(selectedApprover) {
    this.approverRemovedNote = null;
    if (selectedApprover) {
      //check if user exists in approver list
      if (this.findAuthorizer(selectedApprover)) {
        this.isApproverSelected = true;
        if (selectedApprover?.toString().toLowerCase() === this.userDetail?.emailId?.toLowerCase()) {
          this.showApproveButton = true;
        }
        else {
          this.showApproveButton = false;
        }
      }
      else {
        this.isApproverSelected = false;
        this.showApproveButton = false;
        this.approverRemovedNote = this.labelReplacer('msgApproverNotExists');
      }
    }
    else {
      this.isApproverSelected = false;
    }

  }


  findAuthorizer(selectedApprover): any {
    let authIndex = -1;
    let searchObj = null;
    this.authorizerList.forEach(x => {
      if ((authIndex = x.items.findIndex(y => y.label?.toLowerCase() ?? '' === selectedApprover.toLowerCase())) > -1) {
        searchObj = {} = x.items[authIndex];
      }
    });

    return searchObj;
  }

  approveDocumentVersion(approvalType: string) {
    this.apporveBtnState = true;
    this.spinner.show();
    this.formSubmitted = true;
    
    if (this.documentForm.invalid) {
      this.spinner.hide()
      this.apporveBtnState = false;
      return
    }
    
    if (this.canApprovalBeSent()) {
      //approval type = others ->save version / send email / mark version as pending approval
      this.emitVersionResponse.saveType = approvalType;
      if (approvalType.toLowerCase() === 'other') {
        this.saveDocumentVersion('approve')
          .then((res) =>
            this.sendApprovalMail()
              .then((res) => {
                this.apporveBtnState = false;
                this.emitVersionResponse.saveType = approvalType;
                this.outSaveVersion.emit(this.emitVersionResponse);
              })
              .catch((error) => {
                console.log(error);
                this.spinner.hide();
              }))
          .catch((error) => {
            console.log(error)
            this.spinner.hide();
          });
      }
      else if (approvalType.toLowerCase() === 'self') {
        //if approval type = self -> approve version
        this.saveDocumentVersion('approve')
          .then((res) =>
            this.approve()
              .then((res) => {
                this.apporveBtnState = false;
                this.emitVersionResponse.saveType = approvalType;
                this.outSaveVersion.emit(this.emitVersionResponse);
              })
              .catch((error) => {
                console.log(error);
                this.spinner.hide();
              }))
          .catch((error) => {
            console.log(error)
            this.spinner.hide();
          });

      }

    }
    else {
      if (this.draftDocValue?.languageId === 1 || this.draftDocValue?.languageId === 2) {
        this.messageService.add({
          summary: this.labelReplacer('msgErrorTypeApprovalReq'),
          detail: this.labelReplacer('msgErrorFileMissing'),
          sticky: false,
          severity: 'error'
        });
      }
      else {
        this.messageService.add({
          summary: this.labelReplacer('msgErrorTypeApprovalReq'),
          detail: this.labelReplacer('msgErrorEngOrFrApproved'),
          sticky: false,
          severity: 'error'
        });
      }
      this.spinner.hide();

    }


  }

  canApprovalBeSent(): boolean {
    let isAllowed = false;

    if (this.canApproveOtherLang) {
      isAllowed = true;
    }
    else {
      if (this.draftDocValue?.languageId === 1 || this.draftDocValue?.languageId === 2) {
        if (this.checkForAttachmentInDraft()) {
          isAllowed = true;
        }
        else {
          isAllowed = false;
        }
      }
      else {
        isAllowed = false;
      }

    }
    return isAllowed;

  }

  checkForAttachmentInDraft(): boolean {
    let isFileExists = false;
    if (this.isNewDraft) {
      if (this.documentForm.controls['documentLink']?.value !== null
        && this.documentForm.controls['documentLink']?.value !== undefined
        && this.documentForm.controls['documentLink']?.value !== '') {
        isFileExists = true;
      }
      else {
        isFileExists = false;
      }
    }
    else {
      if (this.draftDocValue.documentLink !== null
        && this.draftDocValue.documentLink !== undefined
        && this.draftDocValue.documentLink !== '') {
        isFileExists = true;
      }
      else if (this.documentForm.controls['documentLink']?.value !== null
        && this.documentForm.controls['documentLink']?.value !== undefined
        && this.documentForm.controls['documentLink']?.value !== '') {
        isFileExists = true;
      }
      else {
        isFileExists = false;
      }
    }

    return isFileExists;
  }

  approve() {
    let approveVersion = {};
    approveVersion = this.emitVersionResponse?.versionData;
    approveVersion['absoluteFilePath'] = this.absoluteFilePath;
    return new Promise((resolve, reject) => {
      this.manageDocService.approveDocumentVersion(approveVersion).subscribe(res => {
        if (res.status === 0) {
          //success
          resolve(true);
        }
        else {
          //display error

          reject(false);
        }

      });
    });
  }

  omit_special_char(event) { 
    var k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used) 
   // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    return(k != 47 && k != 92 && k != 58 && k != 42 && k != 63 && k!= 34 && k != 60 && k!= 62 && k != 124); }
    


  sendApprovalMail() {
    this.spinner.show();
    let approveVersion = {};
    approveVersion = this.emitVersionResponse?.versionData;
    //approveVersion['authorizerEmail'] = this.findAuthorizer(approveVersion['approvalRequestedFromGpn']);
    approveVersion['absoluteFilePath'] = this.absoluteFilePath;
    return new Promise((resolve, reject) => {
      this.manageDocService.sendDocumentApprovalMail(approveVersion).subscribe(res => {
        if (res?.data) {
          //success
          resolve(true);
        }
        else {
          reject(false);
        }
      });
    });
  }

  onFileRemove(event) {
    this.pUpload = null;
    this.documentForm.patchValue({
      documentLink: this.draftDocValue.documentLink
    });
  }


}
